module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-2.png?daffd531";